import ActionError from '../ActionError';
import WindowUtils from '../../utils/WindowUtils';

let createActionName = require('../util').createActionName('hpa');

export const START_HPA = createActionName('START_HPA');
export const END_HPA = createActionName('END_HPA');
export const SHOW_HPA_NOT_ALLOWED_MODAL = createActionName(
  'SHOW_HPA_NOT_ALLOWED_MODAL'
);
export const HIDE_HPA_NOT_ALLOWED_MODAL = createActionName(
  'HIDE_HPA_NOT_ALLOWED_MODAL'
);
export const SHOW_HPA_BEGIN_MODAL = createActionName('SHOW_HPA_BEGIN_MODAL');
export const HIDE_HPA_BEGIN_MODAL = createActionName('HIDE_HPA_BEGIN_MODAL');
export const SHOW_HPA_CHANGE_MODAL = createActionName('SHOW_HPA_CHANGE_MODAL');
export const HIDE_HPA_CHANGE_MODAL = createActionName('HIDE_HPA_CHANGE_MODAL');
export const GET_HPA_START_LOCATION = createActionName(
  'GET_HPA_START_LOCATION'
);
export const RECEIVE_HPA_START_LOCATION = createActionName(
  'RECEIVE_HPA_START_LOCATION'
);
export const ERROR_HPA_START_LOCATION = createActionName(
  'ERROR_HPA_START_LOCATION'
);

export const startHpa = (payload) => {
  return {
    type: START_HPA,
    payload,
  };
};

export const exitHpa = () => {
  return {
    type: END_HPA,
  };
};

export const showHpaNotAllowedModal = () => ({
  type: SHOW_HPA_NOT_ALLOWED_MODAL,
});

export const hideHpaNotAllowedModal = () => ({
  type: HIDE_HPA_NOT_ALLOWED_MODAL,
});

export const showHpaBeginModal = () => ({
  type: SHOW_HPA_BEGIN_MODAL,
});

export const hideHpaBeginModal = () => ({
  type: HIDE_HPA_BEGIN_MODAL,
});

export const showHpaChangeModal = () => ({
  type: SHOW_HPA_CHANGE_MODAL,
});

export const hideHpaChangeModal = () => ({
  type: HIDE_HPA_CHANGE_MODAL,
});

export const getHpaStartLocation = () => ({
  type: GET_HPA_START_LOCATION,
});

export const receiveHpaStartLocation = (data) => ({
  type: RECEIVE_HPA_START_LOCATION,
  data: data,
});

export const errorHpaStartLocation = (error) => ({
  type: ERROR_HPA_START_LOCATION,
  error: error,
});

export const goToHpa = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    dispatch(getHpaStartLocation());
    services.api
      .getHPA()
      .then((data) => {
        if (data.payload) {
          resolve(dispatch(receiveHpaStartLocation()));
          WindowUtils.navigate(data.payload);
        } else {
          reject(
            dispatch(
              errorHpaStartLocation(new ActionError('Invalid response payload'))
            )
          );
        }
      })
      .catch((error) => {
        reject(dispatch(errorHpaStartLocation(error)));
      });
  });
};

export const doExitHpa = (reload) => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    services.api
      .exitHpa()
      .then((data) => {
        if (reload) {
          WindowUtils.refresh();
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
